import * as React from 'react'
import { ReactElement } from 'react'
import { useDispatch } from 'react-redux'
import CommandDialog, { Dismiss } from '../Command/CommandDialog'
import TaskForm from '../../Form/Task/TaskForm'
import FormikCommandButtons from '../../Form/FormikCommandButtons'
import useAxios from '../../../hooks/useAxios'
import { getOnSubmitWithCallback } from '../../Form/FormButtons'
import { TaskAction } from '../../../config/taskConfig'
import { useTranslation } from 'react-i18next'

export default function AddTaskDialog(): ReactElement {
    const axios = useAxios()
    const dispatch = useDispatch()
    const { t: translate } = useTranslation()

    return (
        <CommandDialog dialogContentProps={{ title: translate('action.create.task.title') }}>
            {({ onDismiss }: { onDismiss: Dismiss }) => (
                <TaskForm
                    onSubmit={getOnSubmitWithCallback(
                        dispatch,
                        values => ({
                            type: TaskAction.Add,
                            payload: axios.post('/task', values),
                        }),
                        onDismiss,
                    )}
                >
                    <FormikCommandButtons dismiss={onDismiss} />
                </TaskForm>
            )}
        </CommandDialog>
    )
}
